export default {
  ratePlanType: {
    STANDARD: 'Standard',
    BAR: 'Best Available Rate',
    CORPORATE: 'Corporate',
    MEMBER: 'Member',
    PACKAGE: 'Package',
    PROMOTIONAL: 'Promotional',
    OTA: 'OTA',
    WHOLESALE: 'Wholesale',
    NEGOTIATED: 'Negotiated',
    MIXED: 'Mixed rate',
  },
} as const;
